<template>
  <div class="sidebar-navigation customer-sidebar" ref="sidebarWrapper">
    <transition name="fade" mode="out-in">
      <base-inline-loader v-if="$props.loading" height="120" :key="'loader'"/>
      <div v-else :key="'sidebar-menu'">
        <div class="sidebar-inner desktop-menu">
          <ul class="items-menu" role="menu">
              <li role="menuitem"
                  v-for="(account, index) in $props.customerAccounts"
                  :key="'item'+index">
                <a href="#"
                   class="menu-item"
                   :class="{'active': isItemSelected(account)}"
                   @click.prevent="selectAccount(account)"
                   :ref="'menuItem'+account.customerId">
                  <div class="menu-item-inner">
                    <span class="acc-title">{{ getAccountName(account) }}</span>
                    <span class="acc-description">{{
                        `${account.subscriptionInfo.title} - ${account.subscriptionInfo.description}`
                      }}</span>
                  </div>
                </a>
              </li>
          </ul>
        </div>
        <div class="acc-menu acc-dropdown mobile-menu">
          <div class="acc-dropdown-content">
            <button v-for="(account, index) in $props.customerAccounts"
                    :key="'acc'+index"
                    :class="{'active': isItemSelected(account)}"
                    class="acc-details"
                    @click.prevent="selectAccount(account)">
              <i class="acc-icon" :class="getIcon(account.subscriptionInfo.type)" :data-type="account.subscriptionInfo.type"></i>
              <span class="acc-title">{{ getAccountName(account) }}</span>
              <span class="acc-description">{{
                  `${account.subscriptionInfo.title} - ${account.subscriptionInfo.description}`
                }}</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'customer-sidebar',
  props: {
    loading: Boolean,
    customerAccounts: {
      type: Array,
      default: () => []
    },
    blockSelection: Boolean,
    activeItem: String
  },
  data () {
    return {
      selectedAccount: {},
      selectedMenuItem: {}
    }
  },
  computed: {
    selectableAccounts () {
      return this.$props.customerAccounts.filter(account => account.subscriptionInfo.customerId !== this.selectedAccount.subscriptionInfo.customerId)
    }
  },
  methods: {
    getAccountName (account) {
      const { firstName, lastName } = account.subscriptionInfo
      return lastName ? `${firstName} ${lastName}` : firstName
    },
    selectAccount (accountData) {
      if (this.$props.blockSelection) return

      this.$emit('select-account', accountData)

      this.selectedAccount = accountData
    },
    isItemSelected (item) {
      return item.subscriptionInfo.customerId === this.selectedAccount.subscriptionInfo.customerId
    },
    getIcon (type) {
      switch (type) {
        case 'TELEVISION':
          return 'icon-sc-tv'
        case 'INTERNET':
          return 'icon-sc-internet'
        case 'FIXED_TELEPHONY':
          return 'icon-sc-landline'
        case 'MOBILE_PREPAID':
          return 'icon-sc-mobile'
        default:
          return 'icon-sc-mobile'
      }
    }
  },
  watch: {
    customerAccounts: {
      handler (newVal) {
        if (newVal.length) {
          this.selectAccount(newVal.find(i => i.subscriptionInfo.customerId === this.$props.activeItem))
        }
      }
    }
  }
}
</script>
<style scoped lang="scss" src="./styles/sidebar.scss"></style>
<style scoped lang="scss">

.customer-sidebar {
  color: $text;

  @media (map_get($breakpoints, sm)) {
    max-height: 620px;
    min-height: 120px;
    height: auto;
    padding-top: 0;
    padding-bottom: 0;
  }

  .acc-dropdown {
    border-bottom: 1px solid $grey;

    .acc-title {
      display: block;
      font-size: 1.5rem;
      font-weight: 600;
      margin: 0;
      color: $primary;
    }

    .acc-description {
      display: block;
      font-size: 1.2rem;
      color: $dark-grey;
      margin-bottom: 0;
    }

    .acc-dropdown-content {
      background: $white;
      border-radius: 5px;
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.15);

      .acc-title {
        color: $text;
      }

      .acc-details {
        display: block;
        width: 100%;
        text-align: left;
        padding: 1.2rem 2.4rem;

        &:not(:last-child) {
          border-bottom: 1px solid $grey;
        }
      }

      .acc-icon {
        font-size: 3.2rem;
        color: $dark-grey;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }

      &.active {
        &::before {
          position: absolute;
          content: '';
          background: $primary;
          width: 2px;
          height: calc(100% - 2.4rem);
          left: -1.6rem;
          top: 50%;
          transform: translateY(-50%);
        }

        .acc-icon, .acc-title {
          color: $primary;
        }
      }
    }
  }

  .acc-title {
    display: block;
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
    color: $text;
  }

  .acc-description {
    display: block;
    font-size: 1.2rem;
    color: $dark-grey;
    margin-bottom: 0;
  }

  .sidebar-inner {
    padding: 0;

    .items-menu {
      padding-top: 0.8rem;
      padding-bottom: 1rem;

      a.menu-item {
        padding: 0.8rem 2.4rem;
        text-decoration: none;
        margin-bottom: 0;
        line-height: 1.5;
        transition: box-shadow 150ms;
        will-change: box-shadow;

        &.active {
          box-shadow: inset 4px 0 0 $primary;

          .acc-title {
            color: $primary;
          }
        }
      }

      .items-submenu {
        padding-left: 2.4rem;

        li {
          margin-bottom: 0;
        }

        a.submenu-item {
          padding: 0;
          line-height: 2;
        }
      }
    }
  }

  .additional-menu {
    padding: 0 2.4rem 1.6rem;

    li {
      padding: 0.8rem 0;

      h4 {
        font-size: 1.6rem;
        margin: 0;
      }

      p, a {
        font-size: 1.4rem;
        color: $dark-grey;
        outline: none;
        text-decoration: none;
      }
    }
  }

  .desktop-menu {
    display: none;

    @media (map_get($breakpoints, md)) {
      display: block;
    }
  }

  .mobile-menu {
    display: block;

    @media (map_get($breakpoints, md)) {
      display: none;
    }

    .acc-dropdown-content {
      box-shadow: none;
    }

    &.acc-menu {
      border-bottom: none;
    }

    .acc-details {
      margin-left: 1.6rem;
      margin-right: 1.6rem;
      padding: 1.6rem 2.4rem 1.6rem 4.8rem !important;
      width: calc(100% - 3.2rem) !important;
      position: relative;

      &.active {
        &::before {
          position: absolute;
          content: '';
          background: $primary;
          width: 2px;
          height: calc(100% - 2.4rem);
          left: -1.6rem;
          top: 50%;
          transform: translateY(-50%);
        }

        .acc-icon, .acc-title {
          color: $primary;
        }
      }
    }
  }
}
</style>
